import Raven from 'raven-js';
import { pick } from 'lodash';

import newrelic from '@core/lib/newrelic/newrelic';
import { startTracking } from '@core/lib/pendo/pendo';

/**
 * Service for taking of analytics and other
 * external service communications
 */
function Agent() {
  'ngInject';
  let _state = {};

  return {
    setData: setData,
    reset: reset,
  };

  /**
   * @param user
   * @param account
   */
  function setData(user, account) {
    if (_state.user) {
      return;
    }

    const whitelistedProps = [
      'account_ids',
      'current_account_id',
      'id',
      'features',
      'main_account_id',
      'role',
      'timezone_id',
      'ct_role',
    ];

    const userLimitedProps = pick(user, whitelistedProps);

    Raven.setUserContext(userLimitedProps);
    newrelic.setUserContext(user);
    startTracking(user, account);
    _state.user = true;
  }

  /**
   * @ngdoc method
   * @name reset
   * @methodOf adjust.service:Agent
   *
   * @description
   * reset the agent
   *
   */
  function reset() {
    Raven.setUserContext();

    _state = {};
  }
}

export { Agent };
